import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";

const PatientListBase = ({
    items,
    selectedItemId = null,
    selectedItemIds = [],
    onItemClick = null,
    getItemLink = null,
    compact = false,
    renderItemActions = null,
    listSx = {},
}) => {
    return (
        <List
            id="patient-list"
            sx={{
                overflowY: 'auto',
                maxHeight: compact ? '190px' : '300px',
                maxWidth: compact ? '340px' : '300px',
                width: '100%',
                ...listSx,
            }}
        >
            {items.map((item) => {
                const isSelected = selectedItemId === item.id || selectedItemIds.includes(item.id);

                const content = ({ isActive = false } = {}) => (
                    <ListItemButton
                        selected={isActive || isSelected}
                        onClick={onItemClick ? () => onItemClick(item) : undefined}
                        sx={{
                            minHeight: compact ? 40 : 48,
                            py: compact ? 0.35 : 0.75,
                            px: compact ? 1 : 2,
                            '&.Mui-selected': {
                                backgroundColor: 'rgba(0, 0, 0, 0.12)',
                            },
                            '&.Mui-selected:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.18)',
                            }
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: compact ? '34px' : '40px' }}>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={item.title}
                            sx={{
                                color: 'black',
                                fontWeight: (isActive || isSelected) ? 'bold' : 'normal'
                            }}
                            primaryTypographyProps={{
                                sx: {
                                    fontSize: compact ? '0.92rem' : '1rem',
                                    lineHeight: compact ? 1.15 : 1.3
                                }
                            }}
                        />
                        {renderItemActions ? renderItemActions(item) : null}
                    </ListItemButton>
                );

                const link = getItemLink ? getItemLink(item) : null;

                return (
                    <ListItem key={item.id} disablePadding>
                        {link ? (
                            <NavLink
                                to={link}
                                style={{
                                    textDecoration: 'none',
                                    display: 'block',
                                    width: '100%'
                                }}
                            >
                                {({ isActive }) => content({ isActive })}
                            </NavLink>
                        ) : (
                            content()
                        )}
                    </ListItem>
                );
            })}
        </List>
    );
};

export default PatientListBase;
